import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { GdprPrivacyStoreEffects } from './effects';
import { gdprPrivacyReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('gdprPrivacy', gdprPrivacyReducer),
    EffectsModule.forFeature([GdprPrivacyStoreEffects]),
  ],
})
export class GdprPrivacyStoreModule {}
